export const baseEvent = {
  context: 'CONTRACT',
} as const
